import { animate, inView } from 'motion';
import BasePage from '../../components/base-page/base-page';

import './ai-service-offer.scss';

class AiServiceOfferPage extends BasePage {
  ui = {
    imageContainer: '.js-img-container',
  };

  uiCollections = {
    featureImgs: '.js-feature-img',
    featureItems: '.js-feature-item',
    progressBars: '.js-progress-bar',
    appItems: '[data-app-href]',
  };

  events = {
    'click @uiCollections.featureItems': 'handleClickFeatureItem',
    'click @uiCollections.appItems': 'handleClickApp',
  };

  progressBarActiveClass = 'ai-offer-features__bar_active';
  startedAnimationFirstTime = false;
  currentAnimationTimeout;
  isMobile = false;

  onInit() {
    super.onInit();

    const imageContainer = this.ui.imageContainer as unknown as HTMLDivElement;
    const progressBars = this.uiCollections.progressBars as unknown as HTMLDivElement[];

    this.isMobile = Boolean(imageContainer.dataset.isMobile);

    if (this.isMobile) {
      return;
    }

    inView(imageContainer, () => {
      if (!this.startedAnimationFirstTime) {
        progressBars[0]!.classList.add(this.progressBarActiveClass);
        this.startSlideAnimation(0);
        this.startedAnimationFirstTime = true;
      }
    });
  }

  getCurrentItems() {
    const featureImgs = this.uiCollections.featureImgs as unknown as HTMLImageElement[];
    const progressBars = this.uiCollections.progressBars as unknown as HTMLDivElement[];

    const currentImg = featureImgs.find((img) => !img.classList.contains('d-none'))!;
    const currentBar = progressBars.find((bar) => bar.classList.contains(this.progressBarActiveClass))!;

    return { currentImg, currentBar };
  }

  handleClickFeatureItem(e) {
    const { currentImg } = this.getCurrentItems();
    const clickedIndex = Number(e.currentTarget.dataset.barIndex);
    const currentImgIndex = Number(currentImg.dataset.imageIndex);

    if (this.isMobile) {
      return;
    }

    if (clickedIndex === currentImgIndex) {
      return;
    }

    this.startSlideAnimation(clickedIndex);
  }

  startSlideAnimation(imgIndex: number) {
    const featureImgs = this.uiCollections.featureImgs as unknown as HTMLImageElement[];
    const progressBars = this.uiCollections.progressBars as unknown as HTMLDivElement[];
    const imgContainer = this.ui.imageContainer as unknown as HTMLDivElement;

    imgContainer.dataset.activeIndex = String(imgIndex);

    const { currentImg, currentBar } = this.getCurrentItems();

    const nextImg = this.uiCollections.featureImgs[imgIndex] as unknown as  HTMLImageElement;
    const nextBar = progressBars[imgIndex] as unknown as HTMLDivElement;

    currentBar.classList.remove(this.progressBarActiveClass);
    nextBar.classList.add(this.progressBarActiveClass);

    if (this.currentAnimationTimeout) {
      clearTimeout(this.currentAnimationTimeout);
    }

    this.currentAnimationTimeout = setTimeout(() => {
      this.startSlideAnimation((imgIndex + 1) % featureImgs.length);
    }, 6800);

    if (currentImg.dataset.imageIndex === nextImg.dataset.imageIndex) {
      return;
    }

    animate(currentImg, { opacity: [1, 0] }, { duration: 0.5 }).finished.then(() => {
      featureImgs.forEach((img) => img.classList.add('d-none'));
      nextImg.classList.remove('d-none');
      animate(nextImg, { opacity: [0, 1] }, { duration: 0.5 });
    });
  }

  handleClickApp(e) {
    const { appHref } = e.currentTarget.dataset;

    window.open(appHref, '_blank', 'noopener,noreferrer');
  }
}

export default AiServiceOfferPage;

(AiServiceOfferPage as BasePage).initOnDomLoaded();
